import styled from '@emotion/styled';

export const Backdrop = styled.div`
  background-color: #e8e8e8;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  filter: blur(8px);
  background-repeat: repeat-y;
  // z-index: -1;
  background-image: url(${props => props.theme.backgroundUrl});

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: 100% auto;
    background: white;
    opacity: 0.7;
    // z-index: -1;
  }
`;

export const ThemedButton = styled.button`
  color: ${props => props.theme.primaryFontColor};
  background: ${props => props.theme.themeColor};
`;

export const Button = styled(ThemedButton)`
  display: block;
  width: 100%;
  height: 80px;
  line-height: 80px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  text-align: center;
  outline: none;
  border: none;
  user-select: none;
  margin-bottom: 20px;
  font-size: 36px;
  font-weight: normal;
`;

export const ActionButton = styled(Button)`
  font-family: system-ui, Arial;
  margin-bottom: 25px;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 1px;
`;

export const ActionButtonSecondary = styled(ActionButton)`
  color: ${props => props.theme.themeColor};
  background: ${props => props.theme.primaryFontColor};
`;

export const HeaderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 87px;
  padding: 17px 0;
  box-shadow: 0 3px 5px grey;
  z-index: 1;
  text-align: center;
  background: ${props => props.theme.headerColor};
`;

export const Circle = styled.div`
  width: 50px;
  height: 50px;
  min-width: 50px;
  min-height: 50px;
  background: ${props => (props.inverse ? props.theme.themeColor : '#ffffff')};
  border-radius: 50%;
  border-width: 3px;
  border-style: solid;
  position: relative;
  color: ${props => (props.inverse ? '#ffffff' : props.theme.themeColor)};
  border-color: ${props => props.theme.themeColor};
`;

export const CircleCheck = styled.i`
  position: absolute;
  top: 10px;
  left: 11px;
  font-size: 25px;
`;

export const ServiceVariationWrapper = styled.div`
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.19);
  margin-bottom: 15px;
  border-style: ${props => (props.selected ? 'solid' : 'none')};
  border-width: 3px;
  border-color: ${props => props.theme.themeColor};
`;

export const ServiceVariation = styled('div')(({ theme, selected, addon }) => ({
  position: 'relative',
  display: 'flex',
  gap: '24px',
  alignItems: 'center',
  minHeight: '96px',
  padding: '12px 24px',
  fontWeight: 'bold',
  color: !addon && selected ? 'rgb(255, 255, 255)' : theme.secondaryFontColor,
  background: !addon && selected ? theme.secondaryFontColor : '#ffffff',
  borderTop: addon ? `2px solid ${theme.secondaryFontColor}` : null,
  opacity: addon ? 0.8 : 1
}));

export const ClientPerson = styled('div')(({ theme, selected }) => ({
  position: 'relative',
  display: 'flex',
  gap: '24px',
  alignItems: 'center',
  minHeight: '96px',
  padding: '12px 24px',
  lineHeight: '85px',
  textAlign: 'center',
  color: selected ? 'rgb(255, 255, 255)' : theme.themeColor,
  background: selected ? theme.themeColor : '#ffffff'
}));

export const Appointment = styled('div')(({ theme, selected }) => ({
  position: 'relative',
  display: 'block',
  width: '100%',
  boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.2)',
  borderRadius: '6px',
  outline: 'none',
  border: 'none',
  userSelect: 'none',
  marginBottom: '15px',
  fontSize: '28px',
  fontWeight: '700',
  letterSpacing: '1px',
  paddingTop: '30px',
  paddingBottom: '30px',
  color: '#4f4f4f',
  background: '#ffffff',
  textAlign: 'center',
}));

export const ClassSession = styled('div')(({ theme, selected }) => ({
  position: 'relative',
  display: 'block',
  width: '100%',
  boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.2)',
  borderRadius: '6px',
  outline: 'none',
  border: 'none',
  userSelect: 'none',
  marginBottom: '15px',
  fontSize: '28px',
  fontWeight: '700',
  letterSpacing: '1px',
  paddingTop: '30px',
  paddingBottom: '30px',
  color: '#4f4f4f',
  background: '#ffffff',
  textAlign: 'center',
}));
